<!--
  手机号管理
  lovi 2020-1-13
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('securitySet.mobileNumberManagement')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <div class="phone-list">
          <van-cell-group>
            <div v-if="userInfo.phone" class="title text-gray">
              {{ $t("common.mobileNumber") }}
            </div>
            <van-cell
              v-if="userInfo.phone"
              :title="_phoneFormat(userInfo.phone)"
            >
              <span
                slot="default"
                class="text-blue"
                @click="_linkFun('/mobile', 'mobile', { flag: 'edit' })"
              >
                {{ $t("securitySet.changeMobileNumber") }}
              </span>
            </van-cell>
            <van-cell
              v-else
              :title="$t('securitySet.addMobileNumber')"
              is-link
              @click="_linkFun('/mobile', 'mobile', { flag: 'bind' })"
            />
          </van-cell-group>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "phoneManage",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      phoneList: {}
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell-group {
  .title {
    padding: 15px 15px 0 15px;
  }
  .van-cell {
    display: flex;
    align-items: center;
    padding: 10px 15px;
  }
}
</style>
